export type LOS = 'mac' | 'windows' | 'linux';

export const browserUtils = {

    getOS: (): LOS => {
        const userAgent = window.navigator.userAgent;

        const osPatterns: Record<LOS, string> = {
            linux: 'Linux',
            mac: 'Mac',
            windows: 'Windows'
        }

        for (const [os, pattern] of Object.entries(osPatterns)) {
            if (userAgent.includes(pattern)) {
                return os as LOS;
            }
        }
    },
    isMobile: () => {

        const checkRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
        return checkRegex.test(navigator.userAgent);
    }
} as const

